"use strict";
// tslint:disable
// eslint-disable
/**
 * Roles and Rights API
 * API for configurable roles and rights
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
function UserWithRoleFromJSON(json) {
    return UserWithRoleFromJSONTyped(json, false);
}
exports.UserWithRoleFromJSON = UserWithRoleFromJSON;
function UserWithRoleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'displayName': json['displayName'],
        'screenName': !runtime_1.exists(json, 'screenName') ? undefined : json['screenName'],
        'roleName': json['roleName'],
        'rights': json['rights'],
    };
}
exports.UserWithRoleFromJSONTyped = UserWithRoleFromJSONTyped;
function UserWithRoleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'displayName': value.displayName,
        'screenName': value.screenName,
        'roleName': value.roleName,
        'rights': value.rights,
    };
}
exports.UserWithRoleToJSON = UserWithRoleToJSON;
